module.exports = __webpack_public_path__ + "static/media/methodanimation1.580b0d54.gif";